const FAMILY_COVERAGE = 'FamilyCoverage';
const SELF_ONLY_COVERAGE = 'SelfOnlyCoverage' ;

export const ESC_OFFER_TYPES = {
    FAMILY_COVERAGE,
    SELF_ONLY_COVERAGE
};